import { React } from 'react';
import { Text, Checkbox } from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';

function FlagsCheckboxes({ flagsArray, flagsApiName }) {
  const methods = useFormContext();
  return (
    <Controller
      name={flagsApiName}
      control={methods.control}
      render={({ field: { onChange, value } }) => {
        const curatedValue = value || [];
        const handleChange = selectedOption => {
          const selectedOptionValue = selectedOption.target.value;
          const selectedOptionChecked = selectedOption.target.checked;

          if (selectedOptionChecked) {
            onChange([...curatedValue, selectedOptionValue]);
          } else {
            onChange(curatedValue.filter(option => option !== selectedOptionValue));
          }
        };

        return (
          <>
            {flagsArray.map(flag => (
              <Checkbox
                size='lg'
                isChecked={!!curatedValue?.find(i => i === flag.actual_value)}
                key={flag.actual_value}
                onChange={handleChange}
                value={flag.actual_value}>
                <Text fontSize='14px'>{flag.actual_value}</Text>
              </Checkbox>
            ))}
          </>
        );
      }}
    />
  );
}

export default FlagsCheckboxes;
